import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonios } from '../data/testimonios';
import { Emoji } from './Emoji';
export function Testimonios() {
  return <section className="w-full bg-white py-14 sm:py-16" data-id="element-253" data-mp="39zmqem0wltct">
      <div className="mx-auto w-full max-w-[680px] px-4 text-center sm:px-6 lg:max-w-content" data-id="element-254" data-mp="35yj7fqnk7h7d">
        <h2 className="inline-flex flex-wrap items-center justify-center gap-2 font-display text-[clamp(1.5rem,6vw,2.25rem)] font-extrabold leading-[1.08] tracking-tight text-ink-900" data-id="element-255" data-mp="30zzkbmx8bzdf">
          <Emoji symbol="❤️" className="text-3xl" data-id="element-256" data-mp="2rapvqh1lgyu2" />
          Más personas que ya lo tienen
        </h2>

        <ul className="mt-9 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-257" data-mp="2mcwmff4zvopk">
          {testimonios.map(item => <li key={item.name + item.initials} className="h-full" data-id="element-258" data-mp="2ibkxzcxux9iy">
              <figure className="flex h-full flex-col rounded-2xl border border-line bg-canvas p-5 text-center shadow-card sm:p-6" data-id="element-259" data-mp="2dbq739e30jxw">
                <span className="mx-auto flex h-11 w-11 items-center justify-center rounded-full bg-celeste-200 font-display text-xs font-bold text-celeste-800" aria-hidden="true" data-id="element-260" data-mp="28clxihn8wk71">
                  {item.initials}
                </span>
                <span className="mt-3 flex justify-center gap-0.5" aria-label="5 de 5 estrellas" data-id="element-261" data-mp="1ed6027wds2hy">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-gold-500 text-gold-500" aria-hidden="true" data-id="element-262" data-mp="271blkwv9dviu" data-mpi={index} />)}
                </span>
                <blockquote className="mt-4 text-[14px] leading-relaxed text-ink-700 sm:text-[15px]" data-id="element-263" data-mp="22178lgtk7ixd">
                  “{item.quote}”
                </blockquote>
                <figcaption className="mt-auto pt-4" data-id="element-264" data-mp="lpa9lkxen6tm">
                  <span className="block font-display text-sm font-bold text-ink-900" data-id="element-265" data-mp="qnbqbz7cyu1x">
                    {item.name}
                  </span>
                  <span className="mt-1 block text-xs text-ink-400" data-id="element-266" data-mp="6ma3wg27nts6">
                    {item.location} · {item.product}
                  </span>
                </figcaption>
              </figure>
            </li>)}
        </ul>
      </div>
    </section>;
}